<app-animal-details-container [animal]="currentAnimal()" [partialHeight]="true" [showLocator]="true">
  <app-animal-alerts-bar
    [stoppedMovingSince]="stoppedMovingSince()"
    [outOfBoundsSince]="outOfBoundsSince()"
    [abnormalActivitySince]="abnormalActivitySince()"
    [abnormalActivityIsHigh]="abnormalActivityIsHigh()"/>
  <div class="flex-grow-1">
    <div class="mb-3">
      <div class="m-0 fw-bold">Name</div>
      <div class="d-flex justify-content-center mb-3">
        <input (input)="setName($event)"
               [disabled]="loading || !canBeAltered"
               class="form-control border-0 fs-main height-50px inner-shadow rounded-2"
               type="search"
               value="{{ currentAnimal()?.visualTag}}">
      </div>
    </div>
    @if (animalHasNfcTag()) {
      <div class="flex-grow-1">
        <div class="mb-3">
          <div class="m-0 fw-bold">Nùmero do RFID</div>
          <div class="d-flex justify-content-center mb-3">
            <input (input)="setMetadata($event, 'rfid')"
                   [disabled]="loading || !canBeAltered"
                   class="form-control border-0 fs-main height-50px inner-shadow rounded-2"
                   type="search"
                   value="{{ currentAnimal()?.animalMetadata?.rfid}}">
          </div>
          <div class="m-0 fw-bold">Nùmero do SISBOV</div>
          <div class="d-flex justify-content-center mb-3">
            <input (input)="setMetadata($event, 'sisbov')"
                   [disabled]="loading || !canBeAltered"
                   class="form-control border-0 fs-main height-50px inner-shadow rounded-2"
                   type="search"
                   value="{{ currentAnimal()?.animalMetadata?.sisbov}}">
          </div>
        </div>
      </div>
    }
    <div class="mb-3">
      <app-generic-button
        (click)="applyChanges()"
        description="Apply changes"
        [alwaysShowText]="true"
        [buttonText]="'Apply changes'"
        [disabled]="loading || (!metadataHasChanged() && !nameHasChanged()) || !canBeAltered"
        [primaryIcon]="'fa-solid fa-check fa-2x'"/>
    </div>
  </div>
  <div class="mb-1">
    <div class="m-0 fw-bold">Location Data</div>
    <div class="">
      @if (animalHasNfcTag()) {
        <app-generic-button
          class="mb-3"
          [disabled]="nfcScanMoments().length == 0"
          [buttonText]="nfcButtonText()"
          [primaryIcon]="'fa-brands fa-nfc-symbol'"
          description="'Show all scan moments'"
             aria-controls="nfcScansDropdown"
             aria-expanded="false"
             data-bs-target="#nfcScansDropdown"
             data-bs-toggle="collapse">
        </app-generic-button>
        <div class="collapse" id="nfcScansDropdown">
          @for (entry of nfcScanMoments(); track entry; let idx = $index) {
            <div class="rounded-2 background-light-gray p-2 gap-2 pointer pointer-hover-blue mb-2"
                 aria-controls="nfcScanDropdown"
                 aria-expanded="false"
                 [attr.data-bs-target]="'#nfcScanDropdown' +idx"
                 data-bs-toggle="collapse">
              <div>Sample count: {{ entry.sampleCount }}</div>
              <div>Scanned at: {{ entry.scannedAt }}</div>
              <div>Result: {{ entry.failedScan ? 'Success' : 'Failed' }}</div>
              <div>Scanned by: {{ entry.userId }}</div>
            </div>
            <div class="collapse" [attr.id]="'nfcScanDropdown' +idx">
              <div class="row mb-3">
                @for (gpsFix of entry.samples; track gpsFix) {
                  <div>{{ dateTime(gpsFix.instant) }}: {{ gpsFix.value.position.coords }}</div>
                }
              </div>
            </div>
          }
        </div>
      }
      <div class="row mb-3">
        <div class="col-5">
          <i class="fa-solid fa-location-dot"></i>
          {{ lastLocationFixMessage() }}
        </div>
        @if (showBLEData() && lastSeenByBLEScannerMessage() != '?') {
          <div class="col-7">
            <i class="fa-brands fa-bluetooth"></i>
            {{ lastSeenByBLEScannerMessage() }}
          </div>
        }
      </div>
      <div class="row mb-3">
         <span class="col stacked-icons">
             <i class="fa-solid fa-clock-rotate-left"></i>
             <i class="fa-solid fa-location-dot translated-icon pe-2"></i>
           @if (locationStore.numberOfGpsPositionsLast24Hours() !== undefined) {
             {{ locationStore.numberOfGpsPositionsLast24Hours() }} locations last 24h
           } @else {
             -
           }
         </span>
      </div>

      <div class="mb-3">
        @if (showDistance() && locationStore.distance() !== undefined) {
          <div class="statistic">
            <i class="fa-solid fa-shoe-prints"></i> {{ currentAnimal()?.visualTag }}
            walked {{ locationStore.distance() }} in
            the past 48h
          </div>
        }
      </div>
      <div class="mb-3">
        @let currentCoordinates = coordinates();
        @if (currentCoordinates) {
          <div class="statistic copy-coordinates" (click)="onCopyCoordinates()">
            <i class="fa-solid fa-globe"></i> {{ currentCoordinates[0] }}, {{ currentCoordinates[1] }}
            <i class="fa-regular fa-copy"></i>
          </div>
        }
      </div>
    </div>
    <app-generic-button
      (click)="showHistoricalLocations()"
      description="Show historical locations"
      [alwaysShowText]="true"
      buttonText="Show historical locations"
      [primaryIcon]="'fa-solid fa-map-location-dot fa-2x'"
    />
    @if (showGatewayData() || showBatteryData() || showAccelerometerData()) {
      <hr/>
      <div class="m-0 fw-bold">Tag Data</div>
      <div class="statistics">
        @if (showGatewayData()) {
          <div class="statistic">
            <i class="fa-solid fa-tower-cell"></i>
            <div class="d-flex flex-column">
              <span>Last seen by LoRa antenna: {{ lastSeenMessage() }}</span>
              @if (lastRssi() != undefined) {
                <span>Signal strength of latest LoRa packet: {{ lastRssi() }}%</span>
              }
            </div>
          </div>
        }
        @if (showBatteryData()) {
          <div class="statistic {{batterLevelColor()}}">
            <i class="{{batteryIcon()}} {{batterLevelColor()}}"></i>
            @if (batteryVoltage() !== undefined) {
              {{ batteryVoltage() | number: '1.0-2' }}V
            }
            ({{ lastSeenBatteryLevelMessage }})
          </div>
        }
        @if (showAccelerometerData()) {
          <div class="statistic">
            <i class="fa-solid fa-heart-pulse"></i>
            {{ numberOfInterruptsLast24Hours }} movements last 24h
          </div>
        }
        <div class="row mb-3">
          <div class="col-5">
            <i class="fa-solid fa-satellite"></i>
            @if (locationStore.numberOfSatellites() !== undefined) {
              {{ locationStore.numberOfSatellites() }} satellites
            } @else {
              -
            }
          </div>
          @if (!animalHasNfcTag()) {
            <div class="col-7 stacked-icons">
              <i class="fa-regular fa-clock"></i>
              <i class="fa-solid fa-location-dot translated-icon pe-2"></i>
              @if (locationStore.timeToFix() !== undefined) {
                Took {{ locationStore.timeToFix() }} sec for last location
              } @else {
                -
              }
            </div>
          }
        </div>
      </div>
      @if (lastRssi()) {
        <app-generic-button
          (click)="loadRssis()"
          description="Load RSSI values for animal"
          [alwaysShowText]="true"
          [buttonText]="loadingRssis() ? 'Loading RSSI values' : 'Show signal strength for past week'"
          [disabled]="loadingRssis() || loadedRssis()"/>
        @if (loadedRssis() && rssiSeries().length > 0) {
          <div class="signal-strength-graph">
            <ngx-charts-line-chart
              [view]="[350, 300]"
              [results]="rssiSeries()"
              [scheme]="rssiScheme"
              [xAxis]="true"
              [yAxis]="true"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [yScaleMin]="-148"
              [yScaleMax]="0"
              xAxisLabel="Date"
              yAxisLabel="RSSI (dBm)"/>
          </div>
        }
      }
    }
    <hr/>
    @if (!animalHasNfcTag()) {
      <div class="m-0 fw-bold">Animals in range (last hour)</div>
      <app-animals-in-range [animalId]="id()"/>
      @if (showAccelerometerData()) {
        <hr/>
        <div class="m-0 fw-bold">Animal activity</div>
        <app-animal-activity [animalId]="id()"/>
      }
      <hr/>

      <div class="mb-3 d-flex justify-content-between align-items-center pe-2">
        <div class="m-0 fw-bold">Relationships</div>
        <app-action-button
          [icon]="'fa-solid fa-plus'"
          (click)="openRelationships()"
          description="Add relationship"
          [disabled]="loading"/>
      </div>
      @if (parentsOfCurrentAnimal() != undefined && parentsOfCurrentAnimal().length > 0) {
        <div class="m-0 fw-bold">Parents</div>

        @for (parent of parentsOfCurrentAnimal(); track parent) {
          <div class="position-relative">
            <app-animal-button
              class="d-block w-100"
              [selectableForDeletion]="false"
              [selectableForAlteration]="false"
              [standalone]="true"
              [id]="parent.id"/>
            <app-action-button
              class="position-absolute top-50 end-0 translate-middle-y pe-2"
              [btnClass]="'btn-danger-action'"
              [icon]="'fa-solid fa-xmark'"
              (click)="removeRelationship(parent.id, id())"
              description="Remove relationship"
              [disabled]="loading"/>
          </div>
        }

      }
      @if (childrenOfCurrentAnimal() != undefined && childrenOfCurrentAnimal().length > 0) {
        <div class="m-0 fw-bold">Children</div>

        @for (child of childrenOfCurrentAnimal(); track child) {
          <div class="position-relative">
            <app-animal-button class="d-block w-100"
                               [selectableForDeletion]="false"
                               [selectableForAlteration]="false"
                               [standalone]="true"
                               [id]="child.id"/>
            <app-action-button
              class="position-absolute top-50 end-0 translate-middle-y pe-2"
              [btnClass]="'btn-danger-action'"
              [icon]="'fa-solid fa-xmark'"
              (click)="removeRelationship(id(), child.id)"
              description="Remove relationship"
              [disabled]="loading"/>
          </div>
        }

      }
      <hr/>
      <div class="row">
        <div class="m-0 fw-bold">Assigned paddock</div>
      </div>
      <div class="row mb-3">
        <div class="col dropdown">
          <app-generic-button [disabled]="!canBeAltered"
                              aria-controls="editDetailsAssignedPaddockCollapse"
                              data-bs-target="#editDetailsAssignedPaddockCollapse"
                              data-bs-toggle="collapse"
                              [alwaysShowText]="true"
                              [primaryIcon]="'fa-solid fa-border-all fa-2x'"
                              [buttonText]="assignedPaddock?.name || 'Select'"
                              [description]="assignedPaddock?.name || 'Select'"/>
          <div class="collapse"
               id="editDetailsAssignedPaddockCollapse">
            @for (paddock of paddocks(); track paddock.id) {
              <div>
                <div (click)="setPaddock(paddock)" aria-controls="editDetailsAssignedPaddockCollapse"
                     class="btn card m-1"
                     data-bs-target="#editDetailsAssignedPaddockCollapse"
                     data-bs-toggle="collapse">{{ paddock.name }}
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    } @else {
      <div class="mb-3">
        @for (gpsFix of nfcGpsFixes(); track gpsFix) {
          <div class="mb-2">
            <div class="color-danger">- Moved from location <span>A</span> {{ dateTime(gpsFix.instant) }}</div>
            <div class="color-nominal">- Arrived at location <span >B</span> {{ dateTime(demoArrivalInstant(gpsFix)) }}</div>
          </div>
        }
      </div>
    }
    <div class="row">
      <div class="col">
        <div class="m-0 fw-bold">Animal type</div>
      </div>
      @if (!animalHasNfcTag()) {
        <div class="col">
          <div class="m-0 fw-bold">Year born</div>
        </div>
      } @else {
        <div class="col">
          <div class="m-0 fw-bold">Date born: <span class="color-secondary-blue">{{
              currentAnimal()?.dateOfBirth || '?'
            }}</span></div>
        </div>
      }
    </div>
    <div class="row mb-3">
      <div class="col">
        <app-generic-button [disabled]="!canBeAltered"
                            aria-controls="editDetailsAnimalTypeCollapse"
                            aria-expanded="false"
                            data-bs-target="#editDetailsAnimalTypeCollapse"
                            data-bs-toggle="collapse"
                            [alwaysShowText]="true"
                            [primaryIcon]="'fa-solid fa-cow fa-2x'"
                            [buttonText]="currentAnimal()?.type || 'select' | toCapitalizedText"
                            [description]="currentAnimal()?.type || 'select' | toCapitalizedText"/>
        <div class="collapse"
             id="editDetailsAnimalTypeCollapse">
          @for (animalType of animalTypes; track animalType) {
            <div>
              <div (click)="setAnimalType(animalType)"
                   aria-controls="editDetailsAnimalTypeCollapse" class="btn card m-1"
                   data-bs-target="#editDetailsAnimalTypeCollapse"
                   data-bs-toggle="collapse">{{ animalType | toCapitalizedText }}
              </div>
            </div>
          }
        </div>
      </div>
      <div class="col dropdown">
        @if (!animalHasNfcTag()) {
          <app-generic-button [disabled]="!canBeAltered"
                              aria-controls="editDetailsYobCollapse"
                              aria-expanded="false"
                              data-bs-target="#editDetailsYobCollapse"
                              data-bs-toggle="collapse"
                              id="yobDropdownMenuButton"
                              [primaryIcon]="'fa-solid fa-calendar-day fa-2x'"
                              type="button"
                              [alwaysShowText]="true"
                              [buttonText]="currentAnimal()?.yearOfBirth || 'Select'"
                              [description]="currentAnimal()?.yearOfBirth || 'Select'"/>

          <div class="collapse"
               id="editDetailsYobCollapse">
            @for (year of years; track year) {
              <div>
                <div (click)="setYob(year)"
                     aria-controls="editDetailsYobCollapse"
                     class="btn card m-1"
                     data-bs-target="#editDetailsYobCollapse"
                     data-bs-toggle="collapse">{{ year }}
                </div>
              </div>
            }
          </div>
        } @else {

          <ngb-datepicker #dp
                          [classList]="'justify-content-center'"
                          [displayMonths]="1"
                          [maxDate]="today"
                          [ngModel]="dateOfBirth"
                          (dateSelect)="setDateOfBirth($event)"
                          outsideDays="hidden"></ngb-datepicker>
        }
      </div>
    </div>
    @if (canGetPregnant() && !animalHasNfcTag()) {
      <div class="mb-3">
        <div class="d-flex justify-content-between mb-3">
          <div class="m-0 fw-bold">Pregnancy history</div>
          <i class="fa-solid fa-circle-plus fa-2x color-pink pointer pe-3"
             (click)="confirmPregnancy()"></i>
        </div>

        @if (loadingPregnancyHistory()) {
          <div>Loading pregnancy history</div>
        } @else if (pregnancyHistory().length === 0) {
          <div>No historical pregnancies available</div>
        } @else {
          @for (pregnancy of sortedPregnancyHistory(); track pregnancy.id) {
            <div class="mb-3 card p-2">
              <div class="row">
                <div class="col-10">
                  <div>Approximate due date: {{ date(pregnancy?.dueDate) }}</div>
                  <div>Days left: {{ daysUntil(pregnancy?.dueDate) }}</div>
                  <div>Status: <i class="{{ pregnancy?.status | toPregnancyStatusIcon}}"></i></div>
                  <div>Chance: {{ pregnancy?.chance }}%</div>
                </div>
                <div class="col-2 d-flex justify-content-center align-items-center">
                  @if (pregnancy.status == 'ESTIMATED') {
                    <i class="fa-solid fa-circle-plus fa-2x color-pink pointer"
                       (click)="confirmPregnancyById(pregnancy?.id)"></i>
                  }
                  @if (pregnancy.status == 'CONFIRMED') {
                    <i class="fa-solid fa-circle-xmark fa-2x color-danger pointer"
                       (click)="undoPregnancy(pregnancy?.id)"></i>
                  }
                  @if (pregnancy.status == 'ABORTED') {
                    <i class="fa-solid fa-trash fa-2x color-danger pointer"
                       (click)="deletePregnancy(pregnancy?.id)"></i>
                  }
                </div>
              </div>
            </div>
          }
        }
      </div>
    }

    <hr/>

    <div class="row mb-3">
      <div class="m-0 fw-bold">Comments</div>
      <div class="d-flex justify-content-center mb-3">
                    <textarea (input)="setComment($event)"
                              [disabled]="loading || !canBeAltered"
                              class="inner-shadow rounded-2 m-1 w-100"
                              rows="2"
                              type="text"
                              value="{{currentAnimal()?.comment}}"></textarea>
      </div>
      <app-generic-button
        (click)="applyCommentsChange()"
        description="Change comment"
        [alwaysShowText]="true"
        [buttonText]="'Change comment'"
        [disabled]="loading || !commentHasChanged() || !canBeAltered"
        [primaryIcon]="'fa-solid fa-check fa-2x'"/>
    </div>

    <hr/>
    @if (!animalHasNfcTag()) {
      <div class="mb-3">
        <div class="m-0 fw-bold">Weight</div>
        @if (loadingWeightMeasurements()) {
          <div>Loading weight measurements</div>
        } @else if (weightMeasurements().length === 0) {
          <div>No weight measurements available</div>
        } @else {
          <ul>
            @for (measurement of weightMeasurements(); track measurement.id) {
              <li>{{ measurement.submittedAt | date:'longDate' }}
                : {{ measurement.weight }} {{ measurement.unit | weightMeasurementUnit:'abbreviated' }}
              </li>
            }
          </ul>
        }
      </div>

      <app-generic-button aria-controls="addWeightMeasurementCollapse"
                          aria-expanded="false"
                          data-bs-target="#addWeightMeasurementCollapse"
                          data-bs-toggle="collapse"
                          id="addWeightMeasurementCollapseButton"
                          [alwaysShowText]="true"
                          [disabled]="!canBeAltered"
                          [primaryIcon]="'fa-solid fa-scale-balanced fa-2x'"
                          [buttonText]="'Add weight measurement'"
                          description="Add weight measurement"/>
      <div class="collapse mt-3"
           id="addWeightMeasurementCollapse">
        <div class="d-flex flex-column gap-3">
          <app-create-weight-measurement (weightMeasurementCreated)="setWeightMeasurement($event)"/>
          <div class="row">
            <app-generic-button
              (click)="addWeightMeasurement()"
              description="Add weight measurement"
              [alwaysShowText]="true"
              [buttonClass]="'btn btn-info btn-info-shadow'"
              [buttonText]="'Submit weight'"
              [disabled]="weightMeasurement === undefined"
              [primaryIcon]="'fa-solid fa-check fa-2x'"/>
          </div>
        </div>
      </div>

      <hr/>
    }

    <div class="row mb-3">
      <app-generic-button
        (click)="delete()"
        description="Delete animal"
        [alwaysShowText]="true"
        [buttonClass]="'btn-danger btn-danger-shadow'"
        [buttonText]="'Delete animal'"
        [disabled]="loading || !canBeDeleted"
        [primaryIcon]="'fa-solid fa-trash-can fa-2x'"/>
    </div>
    <app-asset-metadata [id]="id()"
                        [relatedDeviceAssociations]="relatedDeviceAssociations()"/>
  </div>
</app-animal-details-container>
